// @flow
import * as React from 'react';
import { PageTitle } from '../../../../shared';
import { Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import { keycloak } from '@coverright/shared/keycloak';
import { SqlCard } from './ui/cards/sql-card';
import { FollowUpCard } from './ui/cards/follow-up-card';
import { AlertList } from './ui/alert-list';
import { LeadStatCard } from './ui/cards/lead-stat-card';
import { RequiredActions } from './ui/required-actions';
import { NextActionList } from './ui/next-action-list';
import { UniqueClosesCard } from './ui/cards/unique-closes-card';


export const Inbox = () => {
  const {agentId} = useParams<{ agentId?: string }>();
  const agent = agentId || keycloak?.tokenParsed?.sub;
  return (
    <>
      <PageTitle title={'Inbox'} />

      <Stack gap={4} direction={'row'} flexBasis={0} flexGrow={2}>
        <Stack gap={4}>
          <Stack gap={4} direction={{ lg: 'row' }} >
            <FollowUpCard agentId={agent} />
            <SqlCard agentId={agent} />
          </Stack>
          <Stack gap={4} direction={{ lg: 'row' }} >
            <UniqueClosesCard agentId={agent} />
          </Stack>
        </Stack>

        <RequiredActions />


        <AlertList agentId={agent} />
      </Stack>
    </>
  );
};


